import { apiGet } from './';
import { BaseResponse, SettingsEntity } from './types';

export class SettingsAPI {
  static async get(id: string) {
    return apiGet<BaseResponse<SettingsEntity>>(
      `policy-portal/tenant/${id}/settings`
    );
  }
}
